<template>
  <g>
    <g
      v-for="(o, i) in misc"
      :key="`misc:${i}`"
      :style="`transform: translate(${o.pos.cx}px, ${o.pos.cy}px)`"
    >
      <path
        v-if="showLabelOverlay"
        :d="miscToIcon(o)"
        :style="
          `transform: translate(${circleRadius}px, 0px) scale(${labelScale *
            0.8})`
        "
      ></path>
      <rect
        :x="-circleRadius"
        :y="-circleRadius"
        :width="circleRadius * 2"
        :height="circleRadius * 2"
        class="misc"
        :style="miscToStyle(o)"
        @mousedown="onClickMisc($event, i)"
      >
        <title>{{ o.name }}</title>
      </rect>
    </g>
  </g>
</template>

<script>
import useMisc from "@/composables/useMisc";
import useBasicStyles from "@/composables/useBasicStyles";
import ui from "@/store/modules/ui";
import { computed } from "@vue/composition-api";

export default {
  props: {
    shouldBlock: Boolean
  },
  setup(props) {
    //
    // Props
    // -------------------------------------------------------------------
    //
    const { shouldBlock } = props;
    //
    // Composables
    // ---------------------------------------------------------------
    //
    const {
      misc,
      move: moveMisc,
      remove: removeMisc,
      types: miscTypes
    } = useMisc();
    const { circleStyles } = useBasicStyles();
    //
    // Events: Click on label
    // -------------------------------------------------------------------
    //
    function onClickMisc(e, i) {
      if (shouldBlock.value) return;
      notifyChange();

      switch (ui.annoType) {
        case "remove":
          removeMisc(e, i);
          break;
        case "move":
          moveMisc(e, i);
          break;
      }
    }
    function notifyChange() {
      if (!ui.hasUnsavedChange) {
        ui.setHasUnsavedChange(true);
      }
    }

    //
    // Styles
    // -------------------------------------------------------------------
    //
    function miscToStyle(miscObject) {
      const colorMap = {
        toilet: "#4363d8",
        bathtub: "#3cb44b",
        kitchen: "#ffe119",
        washingMachine: "#f58231",
        bathroomSink: "#911eb4",
        gasStove: "#e6194b",
        kitchenSink: "#42d4f4",
        na: "#f00"
      };
      const color = colorMap[miscObject.name]
        ? colorMap[miscObject.name]
        : "#ffffff";
      return {
        fill: color,
        ...circleStyles.value
      };
    }

    function miscToIcon(miscObject) {
      const object = miscTypes.find(o => o.value === miscObject.name);
      if (!object) return "";
      return object.icon;
    }

    return {
      misc,
      miscToIcon,
      miscToStyle,
      circleRadius: computed(() => ui.circleRadius),
      showLabelOverlay: computed(() => ui.showLabelOverlay),
      labelScale: computed(() => ui.labelScale),
      onClickMisc
    };
  }
};
</script>

<style lang="scss" scoped>
.misc {
  stroke: #000;
  stroke-width: 1px;
}
.misc:hover {
  stroke: greenyellow;
  stroke-width: var(--stroke-width-hover);
}
</style>
